import { LiPostSort, TimeType } from "@/enum/li-post.enum";

import { LiPostType } from "@/enum/liprofile.enum";

import { CreateLiPost, LiPost } from "../schema/liPost";

/**
 * Strip fields that are irrelevant to the selected post type so the payload only carries
 * the data the chosen source actually uses.
 */
export const normalizeLiPostPayload = (values: CreateLiPost): CreateLiPost => {
	const normalized: CreateLiPost = { ...values };

	if (normalized.type === LiPostType.BY_URL) {
		normalized.posts = false;
		normalized.commentsToComment = false;
		normalized.likesToComment = false;
		normalized.fromMember = undefined;
		normalized.fromOrganization = undefined;
		normalized.query = undefined;
		normalized.timeFrame = undefined;
		normalized.timeStart = undefined;
		normalized.timeEnd = undefined;
		normalized.authorJobTitle = undefined;
		normalized.authorIndustry = undefined;
		normalized.mentionsMember = undefined;
		normalized.mentionsOrganization = undefined;
	} else if (normalized.type === LiPostType.BY_TOPIC) {
		normalized.commentsToComment = false;
		normalized.likesToComment = false;
		normalized.fromMember = undefined;
		normalized.fromOrganization = undefined;
		normalized.postUrl = undefined;
	} else if (normalized.type === LiPostType.BY_PROFILE) {
		if (!normalized.fromMember) {
			normalized.fromMember = undefined;
			normalized.posts = false;
			normalized.commentsToComment = false;
			normalized.likesToComment = false;
		} else if (!normalized.fromOrganization) {
			normalized.fromOrganization = undefined;
			normalized.posts = false;
		}

		normalized.authorJobTitle = undefined;
		normalized.authorIndustry = undefined;
		normalized.mentionsMember = undefined;
		normalized.mentionsOrganization = undefined;
	}

	return normalized;
};

/** Map a persisted LiPost entity onto the form's editable fields (id is handled separately). */
export const mapLiPostToFormState = (liPost: LiPost): Partial<CreateLiPost> => ({
	query: liPost.query,
	repeatDaily: liPost.repeatDaily || false,
	sortBy: liPost.sortBy || LiPostSort.DATE_POSTED,
	authorJobTitle: liPost.authorJobTitle ?? "",
	contentType: liPost.contentType ?? null,
	fromMember: liPost.fromMember ?? undefined,
	fromOrganization: liPost.fromOrganization ?? undefined,
	authorCompany: liPost.authorCompany ?? undefined,
	authorIndustry: liPost.authorIndustry ?? undefined,
	mentionsMember: liPost.mentionsMember ?? undefined,
	mentionsOrganization: liPost.mentionsOrganization ?? undefined,
	timeType: TimeType.PERIOD,
	timeFrame: liPost.timeFrame ?? undefined,
	timeStart: liPost.timeStart ? new Date(liPost.timeStart) : undefined,
	timeEnd: liPost.timeEnd ? new Date(liPost.timeEnd) : undefined,
	postUrl: liPost.postUrl ?? "",
	type: liPost.type ?? LiPostType.BY_TOPIC,
	maxPerPost: liPost.maxPerPost,
	posts: liPost.posts || false,
	commentsToPost: liPost.commentsToPost || false,
	likesToPost: liPost.likesToPost || false,
	likesToComment: liPost.likesToComment || false,
	commentsToComment: liPost.commentsToComment || false,
	plannedScrapingUserId: liPost.plannedScrapingUserId ?? null,
});

/** Whether the post-filter fields hold data and should be expanded on load. */
export const hasAdditionalColumns = (liPost: LiPost): boolean =>
	!!(
		liPost.fromMember ||
		liPost.fromOrganization ||
		liPost.authorCompany ||
		liPost.authorIndustry ||
		liPost.mentionsMember ||
		liPost.mentionsOrganization
	);
